import { MockFactory } from '@tino-frontend/mocks'
import {
  CheckUnicoResultResponse,
  CheckUnicoResultResponseResult,
} from '@types'

export const CheckUnicoResultResponseNotProcessedMock =
  new MockFactory<CheckUnicoResultResponse>({
    result: CheckUnicoResultResponseResult.NOT_PROCESSED,
  })
